import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { Form, FormSubmission, Submission } from '../models/manage-forms.interface';


@Injectable()
export class FormService {


  constructor(private apiService: ApiService, private http: HttpClient) { }


  save(formData: Form): Observable<any> {
    const url = this.apiService.getBaseUrl() + 'form/save'
    return this.http.post<any>(url, formData, {});
  }

  saveSubmission(submission: Submission): Observable<any> {
    console.log("inside saveforlater");
    const url = this.apiService.getBaseHrefUrl() + 'formview/saveSubmission'
    return this.http.post<any>(url, submission, {});
  }

  getForms(departmentCode: string): Observable<Form[]> {
    return this.apiService.createGetServiceCall<Form[]>
      (
        this.apiService.getBaseUrl() + 'form/',
        { 'deptCode': departmentCode }
      );
  }

  getFormById(id: string): Observable<Form> {
    return this.apiService.createGetServiceCall<Form>
      (
        this.apiService.getBaseUrl() + `form/${id}`,
        {}
      );
  }

  getFormViewById(id: string): Observable<Form> {
    return this.apiService.createGetServiceCall<Form>
      (
        this.apiService.getBaseHrefUrl() + `formview/${id}`,
        {}
      );
  }


  getSubmissionById(id: string): Observable<Submission> {
    return this.apiService.createGetServiceCall<Submission>
      (
        this.apiService.getBaseHrefUrl() + `formview/savedForm/${id}`,
        {}
      );
  }


  getFormSubmissions(formId: string): Observable<FormSubmission> {
    const url = this.apiService.getBaseUrl() + 'form/' + formId + '/submissions'
    return this.apiService.createGetServiceCall<FormSubmission>
      (
        url,
        {}
      );
  }

  clearSubmissions(formId: string): Observable<any> {
    const url = this.apiService.getBaseUrl() + 'form/' + formId + '/clear-submissions'
    return this.http.put<any>(url, {});
  }

  resetCurrentCount(formId: string): Observable<any> {
    const url = this.apiService.getBaseUrl() + 'form/' + formId + '/reset-count'
    return this.http.put<any>(url, {});
  }

  deleteRow(id: string) {
    const url = this.apiService.getBaseUrl() + 'form/delete/' + id
    console.log("url", url);
    return this.apiService.createDeleteServiceCall(url, false);
}

   isTitleDuplicated(formId:string, newTitle:string) :Observable<any> {
    const url = `${this.apiService.getBaseUrl()}form/${formId}/check-title-duplication/`
    return this.apiService.createGetServiceCall<any>(url, { newTitle: newTitle });
  }

  copy(formId: string, newTitle: string): Observable<any> {
    const url = `${this.apiService.getBaseUrl()}form/${formId}/copy/`
     return this.apiService.createGetServiceCall<any>(url, { newTitle: newTitle });
  }

  getFormUrl( form: Form):string {
    const urlType = (form.authType === 'CAS') ? 'cas' : (form.authType === 'HS-AD') ? 'ad' : 'public';
    return `${window.location.protocol}/${window.location.host}/hsform/${urlType}/form/view-form?formId=${form.id}`;
  }
}
